module.exports = __webpack_public_path__ + "static/img/3bg_3.54e5797.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_3.png
// module id = 696
// module chunks = 1